import React from "react";
import styled from "@emotion/styled";

const MapContainer = styled.div`
  width: 100%;
  height: 400px;
  margin-bottom: 24px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  overflow: hidden;
`;

const StyledIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
`;

interface VesselFinderMapProps {
  imo?: string;
  mmsi?: string;
  showTrack?: boolean;
}

export const VesselFinderMap: React.FC<VesselFinderMapProps> = ({
  imo: rawImo,
  mmsi,
  showTrack = true,
}) => {
  const extractImoNumber = (input: string | undefined): string | undefined => {
    if (!input) return undefined;

    // If it's a URL, try to extract IMO from it
    try {
      const url = new URL(input);
      // Extract IMO from the pathname or search params
      const matches =
        url.pathname.match(/\/vessels\/.*-imo-(\d+)/i) ||
        url.search.match(/[?&]imo=(\d+)/i);
      if (matches && matches[1]) {
        return matches[1];
      }
    } catch {
      // If not a URL, check if the input itself is an IMO number
      const directMatch = input.match(/^(\d{7})$/);
      if (directMatch) {
        return directMatch[1];
      }
    }
    return undefined;
  };

  const imo = extractImoNumber(rawImo);

  const getVesselFinderUrl = () => {
    const baseUrl = "https://www.vesselfinder.com/aismap";
    const params = new URLSearchParams({
      zoom: "3",
      names: "true",
      show_track: showTrack.toString(),
      ...(imo ? { imo } : {}),
      ...(mmsi ? { mmsi } : {}),
    });
    return `${baseUrl}?${params.toString()}`;
  };

  if (!imo && !mmsi) {
    return null;
  }

  return (
    <MapContainer>
      <StyledIframe
        src={getVesselFinderUrl()}
        title="VesselFinder Map"
        allowFullScreen
      />
    </MapContainer>
  );
};
